import React from "react";
import { Link } from "react-router-dom";
import "./Pages.css";

function Contact() {
  return (
    <article className="page-content">
      <h1>Contact</h1>
      <p>
        Have a question, suggestion, or feedback about CountyLee? We&apos;d like to hear from you.
      </p>

      <h2>Email</h2>
      <p>
        You can reach the creator of CountyLee, Leaton Mitchell, by email at{" "}
        <a href="mailto:leatonm@gmail.com">leatonm@gmail.com</a>. Please include a clear subject line (e.g., &quot;CountyLee question&quot;) so your message is easy to spot.
      </p>

      <h2>Personal Site</h2>
      <p>
        For more about Leaton and other projects, visit{" "}
        <a href="https://leaton.dev" target="_blank" rel="noopener noreferrer">leaton.dev</a>.
      </p>

      <p>
        For how the tool works and common questions, see our <Link to="/faq">FAQ</Link> and <Link to="/about">About</Link> pages.
      </p>
    </article>
  );
}

export default Contact;
